export default __webpack_public_path__ + "static/media/Melodie_9781843628194.c958242b.jpg";